// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"70":"f18c1355","792":"8a6bbc39","871":"10c26f30"}[chunkId] + ".css";
};